import { theme as theme2 } from '@clubspark-react/ui';

import { makeStyles } from 'makeStyles';
import { LIGHT_BLUE, WHITE } from 'theme/colors';
import { themeV2 } from 'theme/themeV2';

export const useStyles = makeStyles()((theme) => ({
  container: {
    margin: `${theme.spacing(1.25)} 0`,
    marginRight: theme.spacing(3.5),
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    '.editContainer': {
      visibility: 'hidden',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme2.fontSizes.medium.value,
      color: themeV2.colors.primary150.value,
      fontWeight: theme2.fontWeights.bold.value,
      marginLeft: theme.spacing(1.5),
    },
    '.underline': {
      visibility: 'hidden',
      width: '100%',
      height: theme.spacing(0.25),
      backgroundColor: LIGHT_BLUE,
      marginTop: theme.spacing(0.25),
    },
    '&:hover': {
      '& .underline': {
        visibility: 'unset',
      },
      '& .editContainer': {
        visibility: 'unset',
      },
      '& .inputValue': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
  label: {
    textAlign: 'start',
    fontSize: theme2.fontSizes.medium.value,
    fontWeight: theme2.fontWeights.bold.value,
    color: theme2.colors.coreGreys100.value,
  },
  content: {
    height: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },
  backdrop: { color: WHITE, zIndex: theme.zIndex.drawer + 1 },
  dialogTitle: {
    padding: theme.spacing(3.5),
    paddingBottom: theme.spacing(2),
    color: theme2.colors.coreGreys100.value,
    fontSize: theme2.fontSizes.large.value,
    fontWeight: theme2.fontWeights.bold.value,
  },
  dialogContent: {
    padding: theme.spacing(3.5),
    paddingTop: '0',
  },
  invisibleInput: { position: 'absolute', left: theme.spacing(33) },
  underlinedInputValue: {
    textAlign: 'start',
    width: '100%',
    fontSize: theme2.fontSizes.medium15.value,
    color: theme2.colors.coreGreys100.value,
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  deleteDialogTitle: {
    paddingBottom: '0px',
  },
  deleteDialogContent: {
    maxWidth: '80vw',
    width: theme.spacing(56),
    margin: theme.spacing(3.5),
    marginTop: theme.spacing(2),
    padding: '0',
  },
}));

export default useStyles;
